// Client-side mirror of the backend internal/contact validators. These give
// early UX feedback in the member/profile forms; the server (member.create /
// member.update operations) is the authoritative gate, so these are
// deliberately no-stricter than the backend — they must never block a value
// the server would accept.
//
// Lives in @sportadmin/shared so the web SPA and the Expo app validate
// identically off one source (mobile-app §5.1). Pure + DOM-free.

// EMAIL_RE matches "local@domain" with no whitespace and exactly one '@'. It
// deliberately does NOT require a dot in the domain, mirroring Go's
// net/mail.ParseAddress (which accepts "a@b"). "asdasdasd" → false.
const EMAIL_RE = /^[^\s@]+@[^\s@]+$/;

// isValidEmail reports whether a non-blank string is a plausibly valid bare
// address. Blank → false (callers decide whether the field is required).
export function isValidEmail(s: string): boolean {
  const e = s.trim();
  return e !== '' && EMAIL_RE.test(e);
}

// isValidPhoneE164 reports whether a value is in canonical E.164 form — the
// shape a phone input emits once libphonenumber accepts the number. Used as a
// lightweight gate where wiring a live libphonenumber parse isn't practical;
// prefer the live verdict (isValidPhoneNumber / onValidityChange) when
// available since it reflects per-country rules.
export function isValidPhoneE164(s: string): boolean {
  const p = s.trim();
  return /^\+[1-9]\d{6,14}$/.test(p);
}
